import { Component, Input } from '@angular/core';
import { ObjectWithCssOptions } from 'projects/common/model/landingModel';

export interface DescriptionDetailedItem {
  icon: ObjectWithCssOptions<string>;
  text: ObjectWithCssOptions<string>;
}

@Component({
  selector: 'description-detailed-item',
  template: `
        <i *ngIf="item?.icon?.value" class="description-detailed-item-icon eva-3-icon-{{item.icon.value}} -eva-3-pr-sm"></i>
        <em *ngIf="item?.text?.value" class="description-detailed-item-title">{{item.text.value}}</em>
    `
})

export class DescriptionDetailedItemComponent {
  @Input() item: DescriptionDetailedItem;

  constructor() { }
}
